module.exports = __webpack_public_path__ + "static/media/space-needle.a4f90a13.jpg";